import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { fetchProjects } from "../lib/api";

export const Route = createFileRoute("/projects")({
  component: Projects,
});

function Projects() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["projects"],
    queryFn: fetchProjects,
  });

  return (
    <>
      <p className="frame-label">
        frame <b>#2</b> — projects()
      </p>
      <div className="sec-head">
        <span className="addr">0x0002</span>
        <h2>projects[] — featured</h2>
      </div>

      {isLoading && <p className="section-sub">// loading...</p>}
      {isError && <p className="section-sub">// could not reach the api</p>}

      {(data?.featured ?? []).map((p) => (
        <div key={p.name} className="frame-card visible">
          <div className="sig">
            {p.name}({p.args ?? ""})
            {p.returns ? ` → ${p.returns}` : ""}
          </div>
          {p.args && <div className="args">args: {p.args}</div>}
          <p>{p.description}</p>
          {p.returns && <div className="ret">→ returns: {p.returns}</div>}
          {p.slug && (
            <Link
              to="/projects/$slug"
              params={{ slug: p.slug }}
              className="cta"
              style={{ marginTop: "1rem", fontSize: "12px", padding: "0.5rem 1rem" }}
            >
              read the full write-up →
            </Link>
          )}
        </div>
      ))}

      <Link to="/experience" className="cta primary">
        step into experience()
      </Link>

      <div className="section-gap">
        <div className="section-title">coursework &amp; smaller builds</div>
        <div className="section-sub">// not featured — no detail pages, just for range</div>
        <div className="compact-table">
          {(data?.coursework ?? []).map((c) => (
            <div key={c.name} className="compact-row">
              <span className="name">{c.name}</span>
              <span className="desc">{c.description}</span>
              {c.url && (
                <a href={c.url} target="_blank" rel="noreferrer">
                  link
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
